// extracted by mini-css-extract-plugin
export var closeWrapper = "styles-module--close-wrapper--af89c";
export var content = "styles-module--content--9b312";
export var contentWrapper = "styles-module--content-wrapper--336d9";
export var description = "styles-module--description--1a4ec";
export var exclamationWrapper = "styles-module--exclamation-wrapper--d4e4e";
export var linkText = "styles-module--link-text--0d8bd";
export var linkWrapper = "styles-module--link-wrapper--5ed63";
export var title = "styles-module--title--4834d";
export var wrapper = "styles-module--wrapper--72daf";